import type { ThemeWithoutTokens } from '../theme.types';

export const badgeTokens = (theme: ThemeWithoutTokens) =>
  ({
    // Badge Size
    badgeHeightSmall: theme.typography.lineHeight.xs,
    badgeHeightMedium: theme.typography.lineHeight.s,
    badgeHeightLarge: theme.typography.lineHeight.m,

    // Badge Padding
    badgePaddingSmall: theme.space.component.x.xs,
    badgePaddingMedium: theme.space.component.x.s,
    badgePaddingLarge: theme.space.component.x.s,

    // Badge Background
    badgeDefaultBackgroundColor: theme.colors.primary.normal,
    badgeLighterBackgroundColor: theme.palette.blue400Alpha,

    // Badge Text Color
    badgeDefaultTextColor: theme.colors.body.textLight,
    badgeLighterTextColor: theme.palette.darkGrey,

    // Badge Font
    badgeFontSize: theme.typography.fontSize.xs,
    badgeFontFamily: theme.typography.fontFamily.regular,
    badgeFontLineHeight: theme.typography.lineHeight.xs,
    badgeFontWeight: theme.typography.fontWeight.semibold,

    // radiuses
    badgeRadiusSmall: '0.5rem',
    badgeRadiusMedium: '0.625rem',
    badgeRadiusLarge: '0.75rem',
  }) as const;
